package com.shadowings.gero.domain.repository

import androidx.datastore.core.DataStore
import androidx.datastore.preferences.core.Preferences

actual fun createDataStore(context: Any): DataStore<Preferences> = createDataStore(
    producePath = { dataStoreFileName }
)

actual fun provideDataStore(): DataStore<Preferences> = createDataStore(Unit)
